

const initialState = {
  showErrNotification: false,
  errNotificationMsg: '',
  pageLoadError: false,
  nbsVo: [],
  nbsError: '',
  nbsLoaded: false,
  nbsApiError: false,
};

export const NBS = (state = initialState, action) => {
  switch (action.type) {
    case 'NBS_RECEIVED':
      return {
        ...state, nbsVo: action.response, nbsLoaded: true, nbsApiError: false,
      };
    case 'NBS_ERROR':
      return { ...state, nbsError: action.response, nbsApiError: true };
    case 'NBS_CALLED':
      return { ...state, nbsCalled: action.response };
    default:
      return state;
  }
};
